"use client";

import React from "react";
import { Button } from "../../ui/button";
import { isBrowser } from "../../../util/env";

interface FooterCookiePreferencesProps {
  children?: React.ReactNode;
}

function FooterCookiePreferences({ children }: FooterCookiePreferencesProps) {
  const showCookiePreferences = () => {
    if (!isBrowser) return;

    window?.Osano?.cm.showDrawer("osano-cm-dom-info-dialog-open");
  };

  return (
    <Button
      appearance="link"
      color="gray"
      sectionName={`footer_cookie_preferences`}
      weight="medium"
      size="sm"
      onClick={showCookiePreferences}
    >
      {children}
    </Button>
  );
}

export default FooterCookiePreferences;
